export default class TemplateGenerator {
  constructor(config) {
    this.$container = config.$container;
    this.pdfUrl = undefined;
    this.exportId = config.exportId;
    this.templateId = config.templateId;
    this.pollUrl = config.pollUrl;
    this.schoolId = config.$container.data('school-id');
    this.progress = 0;
    this.lastCompleted = -1;
    this.stuckCount = 0;
  }

  init() {
    this._initListeners();
    return this;
  }

  _initListeners() {
    this.$container.hide();
    this.pollEndpoint();
  }

  requestedUrl() {
    if (this.pollUrl) {
      return `${this.pollUrl}.json?export_id=${this.exportId}`
    }

    return `/templates/${this.templateId}/waiting.json?export_id=${this.exportId}`
  }

  pollEndpoint() {
    if (this.pdfUrl) {
      if (this.$container.is(":visible")) return;

      $('#loading-message').hide();
      $('#abort-form').hide(); // Hide abort button when complete
      this.$container.show();
      $('#template-link').attr('href', this.pdfUrl);

      // Show failure info if there were failures
      if (this.failedTeachers && this.failedTeachers.length > 0) {
        this.showFailureInfo(this.failedTeachers);
      }

      return;
    }

    $.get(this.requestedUrl())
      .done((data) => {
      this.pdfUrl = data.url;
      this.progress = data.progress || 0;
      this.failedTeachers = data.failed_teachers || [];
      this.hasFailures = data.has_failures || false;
      this.currentExportId = data.export_id;

      // Update progress bar
      $('#progress-bar').css('width', `${this.progress}%`);
      $('#progress-text').text(`${Math.round(this.progress)}%`);

      // Show school name if available
      if (data.school_name && !this.schoolDisplayed) {
        $('#school-info').text(`School: ${data.school_name}`).show();
        this.schoolDisplayed = true;
      }

      // Class Photos With Proofs runs as four sequential phases, each making a
      // different set of pages. The server reports the current phase as
      // class_photos_progress ({ step, label, current, total, unit, percent }),
      // so show a clear "Step N of 4: <doing X> — A of B" instead of the flat,
      // overshooting envelope ratio used for yearbook pages.
      const cpp = data.class_photos_progress;
      if (cpp) {
        const pct = cpp.percent || 0;
        $('#progress-bar').css('width', `${pct}%`);
        $('#progress-text').text(`${pct}%`);
        $('#status-text').text(`Step ${cpp.step} of ${cpp.step_count}: ${cpp.label}`);

        if (cpp.total && cpp.total > 0) {
          $('#page-count').text(`${cpp.current || 0} of ${cpp.total} ${cpp.unit} done`);
        } else if (cpp.step >= 4) {
          $('#page-count').text('Finalizing your download…');
        } else {
          $('#page-count').text('Starting up…');
        }
        $('#retry-status').hide();

        // Stuck detection on the per-item count. The ZIP phase (step 4) is one
        // file with no item movement, so don't warn there.
        if (cpp.step < 4) {
          var cpCurrent = cpp.current || 0;
          if (cpCurrent > 0 && cpCurrent === this.lastCompleted) {
            this.stuckCount++;
            if (this.stuckCount >= 24) {
              var cpStuckMinutes = Math.round(this.stuckCount * 2.5 / 60);
              $('#stuck-warning').text(
                'Warning: No progress for ' + cpStuckMinutes + ' minute(s). ' +
                'The job may be stuck. You can try aborting and restarting, or check Sidekiq.'
              ).show();
            }
          } else {
            this.stuckCount = 0;
            $('#stuck-warning').hide();
          }
          this.lastCompleted = cpCurrent;
        } else {
          this.stuckCount = 0;
          $('#stuck-warning').hide();
        }

        setTimeout(this.pollEndpoint.bind(this), 2500);
        return;
      }

      // Update status text and page count if data is available
      if (data.total && data.total > 0) {
        const studentInfo = data.total_students ? ` (${data.total_students} students)` : '';

        // Check if all pages done but no ZIP yet
        if (data.completed >= data.total && !data.url) {
          $('#status-text').text('All pages generated. Compiling ZIP file...');
          $('#page-count').text(`${data.completed} of ${data.total} pages completed${studentInfo}`);
        } else {
          $('#status-text').text('Generating yearbook pages... Please do not refresh.');
          $('#page-count').text(`${data.completed || 0} of ${data.total} pages generated${studentInfo}`);
        }

        // Show retry status if present
        if (data.status_message && data.status_message.includes('Retry')) {
          $('#retry-status').text(data.status_message).show();
        } else if (data.status_message && data.status_message.includes('Failed')) {
          $('#retry-status').text(data.status_message).removeClass('text-warning').addClass('text-danger').show();
        } else if (data.status_message && data.status_message.includes('Compiling')) {
          $('#retry-status').text(data.status_message).removeClass('text-danger').addClass('text-info').show();
        } else if (data.status_message && data.status_message.includes('photo')) {
          // Show photo-by-photo progress (e.g., "Teacher: photo 5 of 24")
          $('#retry-status').text(data.status_message).removeClass('text-warning text-danger').addClass('text-info').show();
        } else {
          $('#retry-status').hide();
        }
      } else if (data.total === 0 && data.school_name) {
        // total is 0 could mean either no students OR job hasn't set count yet
        if (data.completed > 0) {
          // Job is running, just waiting for count to update
          $('#status-text').text('Generating pages...');
          $('#page-count').text(`${data.completed} pages generated so far...`);
        } else {
          $('#status-text').text('Preparing to generate pages...');
          $('#page-count').text('Job is starting up...');
        }
      } else {
        $('#status-text').text('Preparing to generate pages...');
        $('#page-count').text('Job is starting up...');
      }

      // Stuck job detection: if completed count hasn't changed for 60 seconds (24 polls)
      var currentCompleted = data.completed || 0;
      if (currentCompleted > 0 && currentCompleted === this.lastCompleted) {
        this.stuckCount++;
        if (this.stuckCount >= 24) {
          var stuckMinutes = Math.round(this.stuckCount * 2.5 / 60);
          $('#stuck-warning').text(
            'Warning: No progress for ' + stuckMinutes + ' minute(s). ' +
            'The job may be stuck. You can try aborting and restarting, or check Sidekiq.'
          ).show();
        }
      } else {
        this.stuckCount = 0;
        $('#stuck-warning').hide();
      }
      this.lastCompleted = currentCompleted;

      setTimeout(this.pollEndpoint.bind(this), 2500);
    })
    .fail((jqXHR, textStatus, errorThrown) => {
      console.error('Poll failed:', textStatus, errorThrown);
      $('#status-text').text('Error checking status. Retrying...');
      setTimeout(this.pollEndpoint.bind(this), 5000);
    });
  }

  showFailureInfo(failedTeachers) {
    if (!failedTeachers || failedTeachers.length === 0) return;

    const $failureInfo = $('#failure-info');
    const $failedList = $('#failed-teachers-list');
    const $failureMessage = $('#failure-message');
    const $retryForm = $('#retry-form');

    $failureMessage.text(`${failedTeachers.length} teacher page(s) failed to generate.`);

    // Build the list of failed teachers
    let listHtml = '<ul style="list-style: none; padding: 0;">';
    failedTeachers.forEach(teacher => {
      const errorMsg = teacher.error ? ` - ${teacher.error.substring(0, 100)}` : '';
      listHtml += `<li style="padding: 5px 0; border-bottom: 1px solid #eee;">
        <strong>Teacher ID: ${teacher.teacher_id}</strong>${errorMsg}
        <br><small style="color: #888;">Failed at: ${teacher.failed_at}</small>
      </li>`;
    });
    listHtml += '</ul>';
    $failedList.html(listHtml);

    // Set up retry form
    if (this.schoolId && this.currentExportId) {
      $retryForm.attr('action', `/schools/${this.schoolId}/retry_failed_yb_pages?export_id=${this.currentExportId}`);
    }

    $failureInfo.show();
  }
}
